import * as React from 'react';
import { useRouter } from 'next/router';
import { ExitIntent, ExitIntentCTATile } from './ExitIntent';
import { combineLinkQueryWithUrl } from '../DYHeroBanner/utils';

export interface DYExitIntentTemplateVariables {
  onClick: VoidFunction;
  data: {
    handleCloseExitIntent: VoidFunction;
    title: string;
    text: string;
    ctas: ExitIntentCTATile[];
  };
}

export const DYExitIntent: React.FC<DYExitIntentTemplateVariables> = ({ onClick, data }) => {
  const [isActive, setIsActive] = React.useState(false);
  const isShown = React.useRef(false);

  const { title, text, handleCloseExitIntent } = data;
  const { asPath } = useRouter();
  const ctas: ExitIntentCTATile[] = data.ctas.map(({ ctaText, ctaUrl, ctaImageUrl }) => {
    return {
      ctaText,
      ctaUrl: combineLinkQueryWithUrl(ctaUrl, asPath),
      ctaImageUrl,
    };
  });

  const handleCursorTrack = React.useCallback((event: MouseEvent) => {
    if (event.clientY < 10 && !isShown.current) {
      setIsActive(true);
    }
  }, []);

  const handleClose = () => {
    setIsActive(false);
    isShown.current = true;
    handleCloseExitIntent();
    window.removeEventListener('mousemove', handleCursorTrack);
  };

  React.useEffect(() => {
    if (!isShown.current) {
      window.addEventListener('mousemove', handleCursorTrack);
    }

    return () => {
      window.removeEventListener('mousemove', handleCursorTrack);
    };
  }, [handleCursorTrack]);

  return isActive ? (
    <ExitIntent title={title} text={text} ctas={ctas} onClick={onClick} handleCloseExitIntent={handleClose} />
  ) : null;
};
